<template>
  <div class="claim-distribution">
    <!-- 页面标题 -->
    <div class="page-header">
      <h3>产品理赔分配 - {{ roleInfo.name }}</h3>
    </div>

    <!-- 操作区域 -->
    <div class="operation-area">
      <el-button 
        type="primary" 
        icon="el-icon-check"
        @click="handleSave"
        :loading="saveLoading"
      >
        保存
      </el-button>
      <el-button @click="goBack">返回</el-button>
    </div>

    <!-- 产品列表 -->
    <div class="table-container">
      <el-table
        ref="productTable"
        v-loading="tableLoading"
        :data="productList"
        @selection-change="handleSelectionChange"
        border
        style="width: 100%"
      >
        <el-table-column
          type="selection"
          width="55"
          align="center"
        />
        <el-table-column
          prop="id"
          label="产品类别"
          width="150"
          align="center"
        />
        <el-table-column
          prop="name"
          label="产品名称"
          align="center"
        />
      </el-table>
    </div>
  </div>
</template>

<script>
import request from '@/lib/request'

export default {
  name: 'ClaimDistribution',
  data() {
    return {
      roleId: null,
      roleInfo: {
        name: ''
      },
      productList: [],
      selectedProducts: [],
      tableLoading: false,
      saveLoading: false
    }
  },
  mounted() {
    this.roleId = this.$route.query.id
    if (this.roleId) {
      this.loadRoleInfo()
      this.loadProductList()
      this.loadRoleProducts()
    } else {
      this.$message.error('角色ID不能为空')
      this.goBack()
    }
  },
  methods: {
    // 加载角色信息
    async loadRoleInfo() {
      try {
        const response = await request.request({
          url: '/v1/admin/cmn/role/info',
          method: 'get',
          params: { id: this.roleId }
        })
        
        if (response.err_code === 0) {
          this.roleInfo = response.data
        }
      } catch (error) {
        console.error('获取角色信息失败:', error)
      }
    },

    // 加载产品列表
    async loadProductList() {
      this.tableLoading = true
      try {
        const response = await request.request({
          url: '/v1/admin/cmn/product/list',
          method: 'get'
        })
        
        if (response.err_code === 0) {
          this.productList = response.rows || []
        } else {
          this.$message.error(response.err_msg || '获取产品列表失败')
        }
      } catch (error) {
        console.error('获取产品列表失败:', error)
        this.$message.error('获取产品列表失败')
      } finally {
        this.tableLoading = false
      }
    },

    // 加载角色已分配的产品
    async loadRoleProducts() {
      try {
        const response = await request.request({
          url: '/v1/admin/claim/role/product/list',
          method: 'get',
          params: { role_id: this.roleId }
        })
        
        if (response.err_code === 0) {
          const assignedProductIds = response.rows.map(item => item.product_id)
          this.$nextTick(() => {
            this.setTableSelection(assignedProductIds)
          })
        }
      } catch (error) {
        console.error('获取角色产品分配失败:', error)
      }
    },

    // 设置表格选中状态
    setTableSelection(productIds) {
      this.$refs.productTable.clearSelection()
      this.productList.forEach(product => {
        if (productIds.includes(product.id)) {
          this.$refs.productTable.toggleRowSelection(product, true)
        }
      })
    },

    // 处理选择变化
    handleSelectionChange(selection) {
      this.selectedProducts = selection
    },

    // 保存分配
    async handleSave() {
      this.saveLoading = true
      try {
        const productIds = this.selectedProducts.map(item => item.id)
        
        const response = await request.request({
          url: '/v1/admin/claim/role/product/save',
          method: 'post',
          data: {
            role_id: parseInt(this.roleId),
            product_ids: productIds
          }
        })
        
        if (response.err_code === 0) {
          this.$message.success('保存成功!')
        } else {
          this.$message.error(response.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败')
      } finally {
        this.saveLoading = false
      }
    },

    // 返回
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style scoped>
.claim-distribution {
  padding: 20px;
}

.page-header {
  margin-bottom: 20px;
}

.page-header h3 {
  margin: 0;
  color: #303133;
  font-size: 18px;
  font-weight: 500;
}

.operation-area {
  margin-bottom: 20px;
  padding: 15px;
  background: #f5f7fa;
  border-radius: 4px;
}

.table-container {
  background: #fff;
  border-radius: 4px;
  overflow: hidden;
}
</style>